import Script from 'next/script';
import { withAssetPrefix } from '@/HOC';

export default withAssetPrefix(Script);
